<ng-container *ngIf="user && user.roles; else emptyStateBlock">
  <span *ngFor="let role of user.roles; let last = last">
    {{ Roles.prefix(role.name) | translate }}<span *ngIf="!last">, </span>
  </span>
</ng-container>

<ng-template #emptyStateBlock><span>-</span></ng-template>
